import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  EMAIL_PASSWORD_RESET_TOKEN_VALIDATION,
  EMAIL_PASSWORD_RESET_TOKEN_VALIDATION_SUCCESS,
  EMAIL_PASSWORD_RESET_TOKEN_VALIDATION_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
} from "./actionTypes";

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  passwordResetRequestSuccess: [],
  emailPasswordResetTokenValidationSuccess: [],
  changePasswordSuccess: [],
  changePasswordSuccessLoading: false,
  changePasswordError: null,
};

const ForgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD:
      state = {
        ...state,
      };
      break;
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        passwordResetRequestSuccess: action.payload,
      };
      break;
    case FORGET_PASSWORD_ERROR:
      state = { ...state, passwordResetRequestSuccess: action.payload };
      break;
    case EMAIL_PASSWORD_RESET_TOKEN_VALIDATION:
      state = {
        ...state,
      };
      break;
    case EMAIL_PASSWORD_RESET_TOKEN_VALIDATION_SUCCESS:
      state = {
        ...state,
        emailPasswordResetTokenValidationSuccess: action.payload,
      };
      break;
    case EMAIL_PASSWORD_RESET_TOKEN_VALIDATION_ERROR:
      state = {
        ...state,
        emailPasswordResetTokenValidationSuccess: action.payload,
      };
      break;
    case CHANGE_PASSWORD:
      state = {
        ...state,
        changePasswordSuccessLoading: false,
      };
      break;
    case CHANGE_PASSWORD_SUCCESS:
      state = {
        ...state,
        changePasswordSuccess: action.payload,
        changePasswordSuccessLoading: true,
      };
      break;
    case CHANGE_PASSWORD_ERROR:
      state = {
        ...state,
        changePasswordError: action.payload,
        changePasswordSuccessLoading: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ForgetPassword;
